import { z } from "zod";

export const ForgeMeta = z.object({
  name: z.string(),
  description: z.string().optional(),
});

export type ForgeMeta = z.infer<typeof ForgeMeta>;
